import {t} from '@lingui/core/macro';

import {IDomainCheckFeature} from 'entities/monitor';

export type CheckFeature = Omit<IDomainCheckFeature, 'name'> & {name: string};

export interface IBodyDependentFieldState {
    isFieldActive: boolean,
    isChecked: boolean,
}

export function methodAllowsBody(method: string): boolean {
    return method === 'GET' || method === 'POST';
}

export function shouldResetBodyFields(selective: boolean, bodyMethodDisabled: boolean, method: string): boolean {
    return selective ? bodyMethodDisabled : method === 'HEAD';
}

export function getBodyFieldsToReset(
    keys: readonly string[],
    state: Record<string, IBodyDependentFieldState>,
): string[] {
    return keys.filter((key) => state[key]?.isFieldActive && state[key].isChecked);
}

export function buildCheckFeatures(): CheckFeature[] {
    return [
        {
            name: 'frequent_checking',
            condition: 'monitor_frequent_checking',
            label: t`Учащенный мониторинг`,
            // eslint-disable-next-line max-len
            help: t`Учащённый мониторинг точнее фиксирует инциденты: при сбое проверки идут каждые 5–30 секунд в течение 10 минут или до устранения.`,
        },
    ];
}
